
import { Component, Prop, VModel, Watch } from 'vue-property-decorator';
import AdminTenant from '@/libs/admin/pages/AdminTenant.vue';
import moment from 'moment/moment';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { PlanItemModel } from '@/libs/Api';
import Page from '@/Page.vue';

@Component({
    components: { AdminTenant },
})
export default class WorkTaskDialogFiles extends Page {
    @VModel({ default: false }) dialog!: boolean;
    @Prop() id!: string;
    @Prop() mandatory!: boolean;
    @Prop() shutdownFromDate!: string;

    protected isShutdownEnd: boolean | null = null;
    protected shutdownToDate: string | null = null;
    protected saving = false;
    protected isValid = false;

    protected get isShutdownToDateInFuture() {
        return this.shutdownToDate && new Date(this.shutdownToDate) > new Date();
    }

    @Watch('mandatory')
    mandatoryChanged(v: boolean) {
        this.isShutdownEnd = v;
    }

    mounted() {
        this.onLoad();
    }

    private onLoad() {
        this.isShutdownEnd = null;
        this.shutdownToDate = moment().format('YYYY-MM-DDTHH:mm:ss');
    }

    protected onShutdownFromDateAddMinutes(minutes: number) {
        if (!this.shutdownToDate) {
            this.shutdownToDate = moment().format('YYYY-MM-DDTHH:mm:ss');
        }
        this.shutdownToDate = moment(this.shutdownToDate, 'YYYY-MM-DDTHH:mm:ss')
            .add(minutes, 'minutes')
            .format('YYYY-MM-DDTHH:mm:ss');
    }

    protected couldBeDateAddMinutesInFuture(minutes: number) {
        if (!this.shutdownToDate) {
            return true;
        }
        return new Date(this.shutdownToDate).getTime() + minutes * 60 * 1000 > new Date().getTime();
    }

    protected onSaveClick() {
        if (this.isShutdownEnd) {
            this.saving = true;
            planItemsStore.dispatch(CrudAction.Get, { id: this.id, key: 'EndShutdown' });
            this.subscribe(planItemsStore, CrudReponse.Get, 'EndShutdown').then((planItem: PlanItemModel) => {
                planItem.shutdownToDate = this.shutdownToDate;
                planItemsStore.dispatch(CrudAction.Update, { item: planItem, key: 'EndShutdown' });
                this.subscribe(planItemsStore, CrudReponse.Update, 'EndShutdown').then(() => {
                    this.saving = false;
                    this.$emit('input', false);
                });
            });
        } else {
            this.$emit('input', false);
        }
    }
}
